import _ from 'lodash';
import {
    TABLE_EXPAND_ROW,
    TABLE_HIDE_ROW
} from '../actions/expandableRow';

const initialState = {
    expandedRow: []
};

export default function expandableRow(state = initialState, action) {
    switch (action.type) {
        case TABLE_EXPAND_ROW:
            if (action.keepOthers) {
                return Object.assign({}, state, {
                    expandedRow: _.xorWith(state.expandedRow, [action.rowIndex], _.isEqual)
                });
            }

            return Object.assign({}, state, {
                expandedRow: state.expandedRow.findIndex(
                    item => _.isEqual(item, action.rowIndex)
                ) !== -1 ? [] : [action.rowIndex]
            });
        case TABLE_HIDE_ROW:
            return Object.assign({}, state, {
                expandedRow: []
            });
        default:
            return state;
    }
}

export function createExpandableRowReducer(stateKey) {
    return (state = initialState, action) => {
        if (!action.stateKey || action.stateKey !== stateKey) {
            return state;
        }

        return expandableRow(state, action);
    };
}



// WEBPACK FOOTER //
// ./src/js/reducers/expandableRow.js